import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import { SpiritCountLink } from "../Filtering/SpiritCountLink"
import { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"
import React from "react"

export interface SpiritCountOutcomeTableProps {
	plays: Play[]
	maxSpirits: number
}

export const SpiritCountOutcomeTable = React.memo(function (props: SpiritCountOutcomeTableProps): JSX.Element {

	const table = 'SpiritCountOutcome'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'spiritCount', ascending: true }

	const tableData: TableRow[] = []

	for (let i = 1; i <= props.maxSpirits; i++) {
		tableData.push({
			spiritCount: i,
			lossCount: 0,
			playCount: null,
			winCount: 0,
			winRate: null,
		})
	}

	for (const play of props.plays) {
		if (play.spirits.length > props.maxSpirits) {
			continue
		}

		if (play.outcome.victory) {
			tableData[play.spirits.length - 1].winCount++
		} else {
			tableData[play.spirits.length - 1].lossCount++
		}
	}

	for (const row of tableData) {
		row.playCount = (row.winCount + row.lossCount) || null
		if (row.playCount) {
			row.winRate = row.winCount / row.playCount
		}
	}

	Sorting.sort(tableData, sort, 'playCount')

	return (
		<div>
			<table className="stats spirit-count-outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'spiritCount'} label='Spirits' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'winCount'} label='W' />
						</th>
						<th>
							<SortToggle table={table} field={'lossCount'} label='L' />
						</th>
						<th>
							<SortToggle table={table} field={'playCount'} label='Total' />
						</th>
						<th>
							<SortToggle table={table} field={'winRate'} label='Win %' />
						</th>
					</tr>
				</thead>
				<tbody>
					{
						tableData.map(row =>
							<tr key={row.spiritCount}>
								<th><SpiritCountLink spiritCount={row.spiritCount} /></th>
								<td className='victory'>{row.winCount || ''}</td>
								<td className='loss'>{row.lossCount || ''}</td>
								<td>{row.playCount || ''}</td>
								<td>{row.winRate ? `${(100 * row.winRate).toFixed(1)}%` : ''}</td>
							</tr>
						)
					}
				</tbody>
			</table>
		</div>
	)
})

interface TableRow {
	spiritCount: number
	lossCount: number
	playCount: number | null
	winCount: number
	winRate: number | null
}
